import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './views/search/search.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import { EstimateComponent } from './views/estimate/estimate.component';
import { VmaResultComponent } from './views/estimate/vma-result/vma-result.component';
import { NeighborsTableComponent } from './common/neighbors-table/neighbors-table.component';
import { NeighborsComponent } from './views/neighbors/neighbors.component';
import { PerformanceComponent } from './views/performance/performance.component';
import { RatingModule } from 'ng-starrating';
import { ResultRatingComponent } from './views/estimate/vma-result/result-rating/result-rating.component';
import { ImagePreviewComponent } from './common/image-preview/image-preview.component';
import {NguCarouselModule} from '@ngu/carousel';
import { ResultOverviewComponent } from './views/estimate/vma-result/result-overview/result-overview.component';
import {DecimalPipe} from '@angular/common';
import { SearchArtistsComponent } from './views/search-artists/search-artists.component';
import { SearchArtworksComponent } from './views/search-artworks/search-artworks.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSelectModule} from '@angular/material/select';
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    EstimateComponent,
    VmaResultComponent,
    NeighborsTableComponent,
    NeighborsComponent,
    PerformanceComponent,
    ResultRatingComponent,
    ImagePreviewComponent,
    ResultOverviewComponent,
    SearchArtistsComponent,
    SearchArtworksComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatExpansionModule,
        MatTabsModule,
        MatSelectModule,
        MatToolbarModule,
        RatingModule,
        MatSnackBarModule,
        MatDividerModule,
        NguCarouselModule,
        MatCardModule,
        FlexLayoutModule,
        MatRadioModule,
        MatSliderModule
    ],
  providers: [
    DecimalPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
